/* Empty-state splash for the checklist document view placeholder route
   (dokument/n/i) — a fanned stack of ghost template cards above the
   "choose a document" message. All-gray (gneis), deliberately quiet. */

.splash {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: calc(var(--mantine-spacing-xl) * 1.5);
    padding: var(--mantine-spacing-xl);
    user-select: none;
}

.stack {
    position: relative;
    width: 13rem;
    height: 10rem;
}

.card {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 7rem;
    height: 9rem;
    background-color: var(--mantine-color-body);
    border: 1px solid var(--mantine-color-gneis-3);
    border-radius: var(--mantine-radius-md);
    box-shadow: var(--mantine-shadow-xs);
    transform-origin: bottom center;
}

/* Faint "title bar" on each card */
.card::before {
    content: "";
    position: absolute;
    top: 1rem;
    left: 1rem;
    width: 55%;
    height: 0.4rem;
    border-radius: var(--mantine-radius-sm);
    background-color: var(--mantine-color-gneis-3);
}

/* Faint "text lines" below the title */
.card::after {
    content: "";
    position: absolute;
    top: 2.25rem;
    left: 1rem;
    right: 1rem;
    height: 4.5rem;
    background-image: repeating-linear-gradient(
        to bottom,
        var(--mantine-color-gneis-2) 0,
        var(--mantine-color-gneis-2) 0.25rem,
        transparent 0.25rem,
        transparent 1rem
    );
}

/* Back cards: fanned out and faded; front card upright on top. */
.card:nth-child(1) {
    transform: translateX(-50%) translateX(-2.75rem) rotate(-9deg);
    opacity: 0.6;
}

.card:nth-child(2) {
    transform: translateX(-50%) translateX(2.75rem) rotate(9deg);
    opacity: 0.6;
}

.card:nth-child(3) {
    transform: translateX(-50%);
}

.message {
    margin: 0;
    max-width: 24rem;
    font-size: var(--mantine-h3-font-size);
    font-weight: 500;
    color: var(--mantine-color-gneis-6);
    text-align: center;
    text-wrap: balance;
}

@media (prefers-reduced-motion: no-preference) {
    /* Fade the splash as a whole — group opacity composites the cards as
       one layer, so the overlapping cards don't bleed through each other
       while semi-transparent. */
    .splash {
        animation: splash-rise 400ms ease-out;
    }

    @keyframes splash-rise {
        from {
            opacity: 0;
            translate: 0 var(--mantine-spacing-md);
        }
    }
}
